'use strict';

import React from 'react';
import { useState } from 'react';

import { Button, Form, Stack, Row, Col } from 'react-bootstrap';

import { Formik } from 'formik';
import * as yup from 'yup';

import useRequest from '../helper/useRequest';
import { toast } from 'react-toastify';

import {
    email
} from '../helper/Schema';

// schema for form validation
const schema = yup.object().shape({
    email: email,
});

function Password({ setShowPasswordReset }) {
    const { request } = useRequest();

    const [success, setSuccess] = useState(false);

    //Login Funktion
    //Wird aufgerufen wenn Formular abgesendet
    const login = async (values) => {
        try {
            let result = await request('/Login/Password', values);
            let json = result.data;

            if (json.r == 0) {
                return toast.error(json.message);
            }
            setSuccess(true);
        }
        catch (ex) {
            toast.error(ex.message);
            console.error(ex);
            return;
        }
    }

    if (success) {
        return (
            <>
                <h1>Passwort Wiederherstellen</h1>
                <p>Wir haben Ihnen eine E-Mail mit Anweisungen, wie Sie Ihr Passwort wiederherstellen können, zugeschickt.</p>
            </>
        );
    }

    return (
        <Formik
            validationSchema={schema}
            onSubmit={(values) => {
                login(values);
            }}
            initialValues={{
                email: '',
            }}
        >
            {({
                handleSubmit,
                handleChange,
                handleBlur,
                values,
                touched,
                isValid,
                errors,
            }) => (
                <>
                    <h1>Passwort vergessen</h1>
                    <p>Hier können Sie ein neues Passwort anfordern. Tragen Sie dazu bitte Ihre E-Mail-Adresse ein.</p>
                    <Form id="login-form" noValidate onSubmit={handleSubmit}>
                        <Form.Group className="mb-3" controlId="email">
                            <Form.Control isInvalid={errors.email && touched.email} type="email" placeholder="E-Mail-Adresse" name="email" value={values.email} onBlur={handleBlur} onChange={handleChange} />
                            <Form.Control.Feedback type="invalid">
                                {errors.email}
                            </Form.Control.Feedback>
                        </Form.Group>

                        <Row>
                            <Col xs={6} className="text-left">
                                <button className="btn btn-dark" type="button" onClick={(e) => setShowPasswordReset(false) }>
                                    <i className="fa-solid fa-arrow-left mr-2"></i>Zum Login
                                </button>
                            </Col>
                            <Col xs={6} className="text-right">
                                <Button variant="secondary" type="submit">
                                    <i className="fa-solid fa-check mr-2"></i>Anfordern
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </>
            )}
        </Formik>
    );
}

export default Password;